// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabDocuments-moduleRequestProfileTabDocuments__QmEZG";
var _2 = "RequestProfileTabDocuments-moduleuploadBtn__izZjz Select-moduleSelect__MROu3";
export { _1 as "RequestProfileTabDocuments", _2 as "uploadBtn" }
